import React, { useEffect, useRef, useState } from "react";
import { ISearch } from "../../../models/WareHouseModel";
import { useIntl } from "react-intl";
import { PaginationLength } from "../../../../_metronic/partials/pagination/PaginationLength";
import { PaginationHeader } from "../../../../_metronic/partials/pagination/PaginationHeader";
import { useHistory } from "react-router-dom";
import { Paginate } from "../../../../_metronic/partials/pagination/Paginate";
import { PaginateModel } from "../../../models/PaginateModel";
import queryString from "query-string";
import { formatPrice } from "../../../selectors";
import { HeaderModel, ModalModel } from "../../../models/CommonModel";
import { DEFAULT_PER_PAGE } from "../../../constants/common";
import { AsyncSelect2 } from "../../../../_metronic/partials/select/AsyncSelect2";
import { STORES_ENDPOINT } from "../../../constants/endpoints";
import { getListProducts } from "../import-request/ImportRequestCRUD";
import { ImportRequestDetailModel } from "../../../models/ImportRequestModel";
import ImportRequestHistTable from "./ImportRequestHistTable";
import Flatpickr from "react-flatpickr";
import moment from "moment";

const ImportRequestHist = () => {
    const initRange:any = [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
    const initSearch = {
        page: 1,
        per_page: DEFAULT_PER_PAGE,
        start_date: initRange[0],
        end_date: initRange[1],
    }
    const intl = useIntl();
    const history = useHistory();
    const [search, setSearch] = useState<ISearch>(initSearch)
    const [dataPaginate, setDataPaginate] = useState<PaginateModel<ImportRequestDetailModel>>();
    const [subTotal, setSubTotal] = useState<number>(0);
    const fp = useRef<any>(null);
    const searchHistory = history.location.search;
    const [hideCols, setHideCols] = useState<string[]>([]);
    const [selectedStore, setSelectedStore] = useState(null);
    const [configModal, setConfigModal] = useState<ModalModel>({
        show: false,
        mode: 'add',
    });
    const parseParams = (params: ISearch) => {
        if (params.page) {
            params.page = +params.page
        }
        if (params.per_page) {
            params.per_page = +params.per_page
        }
        return params
    }

    const initParams: ISearch = parseParams(queryString.parse(searchHistory))

    useEffect(() => {
        document.title = 'Sento Supplier - Lịch sử nhập hàng';
    })

    useEffect(() => {
        const params = { ...search, ...initParams }
        getList({ ...params });
        setSearch({ ...params })
    }, [])


    const getList = async (params: ISearch) => {
        const { data: resData } = await getListProducts(params);
        setDataPaginate(resData?.paginate_data);
        setSubTotal(resData?.sum_total ?? 0)
        if (fp.current && fp.current.flatpickr) {
            fp.current.flatpickr.setDate([moment(params.start_date).toDate(), moment(params.end_date).toDate()]);
        }
    }

    const handlePageLengthChange = (e: any) => {
        getList({ ...search, page: 1, per_page: +e.target.value })
    }

    const handlePageChange = (data: any) => {
        getList({ ...search, page: data.selected + 1 })
    }

    const handleSearch = (e: any) => {
        e.preventDefault();
        getList({ ...search, page: 1 })

    }

    const handleClearSearch = (e: any) => {
        e.preventDefault();
        if (fp.current?.flatpickr) {
            fp.current.flatpickr.clear();
        }
        getList({ ...initSearch })
        setSelectedStore(null)
        setSearch({
            ...initSearch
        });
    }

    const handleKeyDown = (e: any) => {
        if (e.key === 'Enter') {
            handleSearch(e);
        }
    }

    const header: HeaderModel[] = [
        {
          label: intl.formatMessage({ id: 'PRODUCTS.NAME' }),
          field: 'name',
          style: { maxWidth: "180px", minWidth: "180px", },
          sortable: true
        },
        {
          label: 'Cửa hàng',
          field: 'store',
          style: { maxWidth: "120px", minWidth: "120px", },
          sortable: true
        },
        {
          label: 'Đơn giá',
          field: 'price',
          style: { maxWidth: "100px", minWidth: "100px", },
          sortable: false
        },
        {
          label: 'Số lượng',
          field: 'quantity',
          style: { maxWidth: "130px", minWidth: "130px", },
          sortable: false
        },
        {
          label: 'VAT',
          field: 'vat',
          style: { maxWidth: "50px", minWidth: "50px", },
          sortable: false
        },
        {
          label: 'Ngày nhận hàng',
          field: 'approved_at',
          style: { maxWidth: "200px", minWidth: "200px", },
          sortable: true
        }
    ]

    const handleSort = (sortBy: string, direction: 'asc' | 'desc' | 'none') => {
        const currentSearch = { ...search };
        const sortParams: ISearch = { ...currentSearch, sort_by: sortBy, sort_direction: direction };
        if (direction === 'none') {
            delete sortParams.sort_by;
            delete sortParams.sort_direction;
        }
        getList({ ...sortParams });
    }

    return <div className="card">
        <div className="card-header py-4">
            <div className="col-md-12">
                <form onSubmit={handleSearch}>
                    <div className="row">
                        <div className='col-md-3 mb-2'>
                            <label className="form-label" htmlFor="name">Tên sản phẩm</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Tên sản phẩm"
                                name="name"
                                id="name"
                                autoComplete='nope'
                                value={search.name || ''}
                                onChange={(e) => setSearch({ ...search, name: e.target.value })}
                                onKeyDown={(e) => handleKeyDown(e)}
                            />
                        </div>
                        <div className='col-md-3 mb-2'>
                            <label className='form-label'>Cửa hàng</label>
                            <AsyncSelect2
                                sourceUrl={`${STORES_ENDPOINT}`}
                                defaultOptions
                                default
                                name='store_id'
                                value={selectedStore}
                                onChange={(selectedOption: any) => {
                                    setSearch({ ...search, store_id: selectedOption ? selectedOption.value : '' })
                                    setSelectedStore(selectedOption);
                                }}
                            />
                        </div>
                        <div className='col-md-3 mb-2'>
                            <label className="form-label">{intl.formatMessage({ id: 'COMMON.TIME' })}</label>
                            <Flatpickr
                                ref={fp}
                                onChange={(date) => {
                                    let startDate = moment(date[0]).format('YYYY-MM-DD');
                                    let endDate = moment(date[1]).format('YYYY-MM-DD');
                                    setSearch({ ...search, start_date: startDate, end_date: endDate });
                                }}
                                options={{
                                    mode: "range",
                                    dateFormat: 'd-m-Y',
                                    enableTime: false,
                                    defaultDate: [moment().format('DD-MM-YYYY'), moment().format('DD-MM-YYYY')],
                                }}
                                className='form-control'
                                placeholder=''
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className='col-md-5 mb-2 d-flex'>
                            <div className="row">
                                <button
                                    className="col-auto btn btn-primary mt-2 me-2"
                                    onClick={handleSearch}
                                >
                                    <i className="bi bi bi-search fs-4"></i> {intl.formatMessage({ id: 'COMMON.SEARCH' })}
                                </button>
                                <button
                                    className="col-auto btn btn-danger mt-2 me-2"
                                    type="button"
                                    onClick={handleClearSearch}
                                >
                                    <i className="bi bi-eraser-fill fs-1"></i>
                                </button>
                            </div>
                        </div>
                    </div>

                </form>
            </div>
        </div>
        <div className="card-body">
            <div className="justify-content-between align-items-center my-3 row">
                <div className='col-12'>
                    <PaginationHeader
                        from={dataPaginate?.meta?.from || 0} to={dataPaginate?.meta?.to || 0}
                        total={dataPaginate?.meta?.total || 0}
                    />
                </div>
                <div className='col-12 col-md-4'>
                    <h3>Tổng giá trị: <span className="text-bold">{formatPrice(subTotal)} VNĐ</span></h3>
                </div>
            </div>
            <ImportRequestHistTable
                data={dataPaginate?.data || []}
                openColConfig={() => setConfigModal({ ...configModal, show: true })}
                header={header}
                hideCols={hideCols}
                handleSort={handleSort}
            />
        </div>
        <div className="card-footer d-flex justify-content-between paginate-wrapper">
            <PaginationLength selected={search.per_page || DEFAULT_PER_PAGE} onChange={handlePageLengthChange} />
            <Paginate
                pageCount={dataPaginate?.meta?.last_page || 0}
                onPageChange={handlePageChange}
                forcePage={(search.page || 1) - 1}
            />
        </div>
        {/* <ConfigModal
            {...configModal}
            header={header}
            hideCols={hideCols}
            handleChangeVisCols={handleChangeVisCols}
            onClose={() => { setConfigModal({ ...configModal, show: false }) }}
        /> */}
    </div>
}
export default ImportRequestHist;